import { Component, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { deepCopy } from 'na-lib';

@Component({
    selector: 'app-form-edit-field-options-dialog',
    templateUrl: './form-edit-field-options-dialog.component.html',
    styleUrl: './form-edit-field-options-dialog.component.css',
    standalone: false
})
export class FormEditFieldOptionsDialogComponent {
  optionsForm!:FormGroup

  constructor(
    public dialogRef: MatDialogRef<FormEditFieldOptionsDialogComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ){
    dialogRef.disableClose = true;
  }

  ngOnInit(){
    const optionData = deepCopy(this.data.values)
    const {title, value,id} = optionData

    this.optionsForm = this.fb.group({
      title:[{value: title ? title : undefined, disabled:false}, this.data?.translate ? '' : Validators.required],
      value:[{value: value ? value : undefined, disabled: this.data?.translate},  this.data?.translate ? '' : Validators.required],
      id:[{value: id ? id : undefined, disabled:false},  Validators.required]
    })

    this.optionsForm.get('title').valueChanges.subscribe(value => {
      if(!this.data?.translate)
      this.optionsForm.patchValue({value: value.replace(' ', '')} )
    })
  }

  onSave(){
    const {title, value, id} = this.optionsForm.value
    if((this.data?.translate) || (title && value && id))
    this.dialogRef.close([{title, value, id}, true])
  }

  onCancel(){
    this.dialogRef.close([this.data.values, false])
  }
}
